import React, { forwardRef } from 'react';
import { Select } from './Select';
import type { SelectOption } from 'types/index';

type CountryCodeSelectProps = Omit<
  React.ComponentProps<typeof Select>,
  'searchable' | 'searchPlaceholder'
> & {
  options: SelectOption[];
};

export const CountryCodeSelect = forwardRef<
  HTMLSelectElement,
  CountryCodeSelectProps
>((props, ref) => (
  <Select
    ref={ref}
    searchable
    searchPlaceholder="Search country or code..."
    {...props}
  />
));

CountryCodeSelect.displayName = 'CountryCodeSelect';
